export default "__VITE_ASSET__BTfxCaGK__"